import Event from './EventService';
import moment from 'moment';
import {ChartSortTrainings} from '@/services/types';
import {TrainingCategory} from "@/components/types";

interface ChartC {
  [id: string]: Array<string>;
}

type Audit = {
  status: string;
  title: string;
  deadline: string;
  id: string;
  isActive: boolean;
  safetyEducationIndex: number;
  tags: TrainingCategory[];
};

type Chart = {
  header: Array<Audit>;
  column: Array<Array<string>>;
};

export default {
  getChartDetail: async (
    token: string,
    year: string,
    main: boolean,
    group: string,
    sortBy: ChartSortTrainings
  ): Promise<Chart> => {
    const {data: chartData} = await Event.getChartInfo(
      token,
      year,
      main,
      group,
      sortBy
    );
    return {
      header: chartData.header.map(d => {
        return {
          status: 'doing',
          title: d.title,
          deadline: d.deadline,
          id: '', // 未使用
          isActive: d.isActive,
          safetyEducationIndex: d.safetyEducationIndex,
          tags: d.tags,
        };
      }),
      // 画面に表示しないデータ(しかし調査のためにjsonには含めたい)が先頭に含まれているので除外
      column: chartData.rows.map(row => row.slice(2)),
    };
  },
};
